/* eslint-disable @typescript-eslint/no-explicit-any */
import { AlertColor, Box, Button, Checkbox, Dialog, Divider, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { LayoutBase } from '../../layouts';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ReadingServices } from '../../services/api/reading/ReadingServices';
import ContainerGraficos from '../../components/custom/charts/ContainerGraficos';
import { Add, CloudUpload, Download } from '@mui/icons-material';
import { ToolsDamInformation } from '../../components/custom';
import { CustomAlert, VMenu } from '../../components/shared';
import { useAuthContext } from '../../context';

export default function GraficosLeituras() {

	const { userData } = useAuthContext();

	const { id } = useParams();
	const navigate = useNavigate();
	const [data, setData] = useState<any>([]);
	const [select, setSelect] = useState<string>('');
	const [dialog, setDialog] = useState<boolean>(false);
	const [selected, setSelected] = useState<[string, string]>(['', '']);
	const [alertInfo, setAlertInfo] = useState({
		open: false,
		message: '',
		severity: 'info' as AlertColor,
		key: ''
	});

	const pagePermissionsString: string | undefined = useMemo(() => {
		return userData?.nivel_acesso?.registros?.monitoramento;
	}, [userData]);

	const hasActionPermission = useCallback((action: 'add' | 'edit' | 'remove' | 'view'): boolean => {
		if (typeof pagePermissionsString === 'string' && pagePermissionsString !== '') {
			const actions = pagePermissionsString.split(',').map(s => s.trim());
			return actions.includes(action);
		}
		return false;
	}, [pagePermissionsString]);

	useEffect(() => {
		if (id) {
			fetchData(id);
		}
	}, [id]);

	useEffect(() => {
		if (id) {
			fetchData(id);
		}
	}, []);

	async function fetchData(uuid: string) {
		const response = await ReadingServices.getAll(uuid);
		if (response instanceof Error) {
			console.log(response.message);
		} else {
			const dadosSemUltimo = response.slice(0, -1);
			setData(dadosSemUltimo);
		}
	}

	function selectInstrument(value: string) {
		setSelect(value);
	}

	const handleToggle = (uuid: string, nome: string) => {
		setSelected((prev) => (prev[0] === uuid ? ['', ''] : [uuid, nome]));
	};

	async function csvDown() {
		if (!hasActionPermission('view')) {
			setAlertInfo({ key: Date.now.toString(), message: 'Você não tem permissão para baixar leituras de instrumentos.', severity: 'error', open: true });
			return;
		}

		const response = await ReadingServices.downloadReadings(selected[0]);

		if (response instanceof Blob) {
			const url = window.URL.createObjectURL(new Blob([response]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', `${selected[1]}.csv`);
			document.body.appendChild(link);
			link.click();
			link.parentNode?.removeChild(link);
			window.URL.revokeObjectURL(url);
			setSelected(['', '']);
		} else {
			setAlertInfo({ key: Date.now.toString(), message: 'Erro ao baixar csv', severity: 'error', open: true });
		}
	}

	function handleAlert(menssage: string, severity: AlertColor) {
		setAlertInfo({ key: Date.now.toString(), message: menssage, severity: severity, open: true });
	}

	return (
		<LayoutBase
			title='Leituras.'
			tollBar={<ToolsDamInformation />}
		>
			<Box>
				<VMenu id={id} />
				<Box padding={2}>
					<Grid container spacing={2}>
						<Grid item xs={6}>
							<FormControl fullWidth>
								<InputLabel>Instrumento</InputLabel>
								<Select label='instrumento' value={select} onChange={(e) => selectInstrument(e.target.value)}>
									<MenuItem value='piezometro'>Piezômetro</MenuItem>
									<MenuItem value='indicador'>Indicador de nível da água</MenuItem>
									<MenuItem value='vazao'>Medidor de vazão</MenuItem>
									<MenuItem value='regua'>Régua de reservatório</MenuItem>
									<MenuItem value='re'>Ré topográfica</MenuItem>
									<MenuItem value='pluviometro'>Pluviométrico</MenuItem>
									<MenuItem value='marco'>Marco Topográfico</MenuItem>
									<MenuItem value='inclinometro'>Inclinômetro</MenuItem>
									<MenuItem value='cota'>Cota</MenuItem>
									<MenuItem value='poco'>Poços de alívio</MenuItem>
									{/* <MenuItem value='marco_deformacao_conduto'>Marco de deformação do conduto</MenuItem>
								<MenuItem value='piezometro_pneumatico'>Piezômetro pneumático</MenuItem>
								<MenuItem value='marco_superficial'>Marco superficial</MenuItem>
								<MenuItem value='placa_de_recalque'>Placa de recalque</MenuItem>
								<MenuItem value='caixa_sueca'>Caixa sueca</MenuItem>
								<MenuItem value='poco_de_alivio'>Poço de alívio</MenuItem>
								<MenuItem value='celula_de_pressao_total'>Célula de pressão total</MenuItem> */}

									{/* <MenuItem value='todos'>Todos</MenuItem> */}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={6}>
							<Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', flexDirection: 'row', gap: 5, mt: 1 }}>
								{hasActionPermission('add') && (
									<Button
										variant='contained'
										sx={{ borderRadius: '25px' }}
										startIcon={<Add />}
										onClick={() => navigate(`/information_dam/${id}/instrument_reading`)}
									>
										Novo
									</Button>
								)}
								{hasActionPermission('add') && (
									<Button
										variant='contained'
										sx={{ borderRadius: '25px' }}
										startIcon={<CloudUpload />}
										onClick={() => navigate(`/information_dam/${id}/instrument_reading/import`)}
									>
										Importar
									</Button>
								)}
								{hasActionPermission('view') && (
									<Button
										variant='contained'
										sx={{ borderRadius: '25px' }}
										onClick={() => setDialog(true)}
										startIcon={<Download />}
									>
										CSV
									</Button>
								)}
							</Box>
						</Grid>
						<Grid item xs={12}>
							{data !== null && select !== '' && userData.uuid && id && (
								<ContainerGraficos
									instrumentos={data}
									tipoSelecionado={select}
									barragem_id={id}
									user_id={userData.uuid}
									alert={handleAlert}
								/>
							)}
						</Grid>
					</Grid>
				</Box>
			</Box>
			<Dialog open={dialog} onClose={() => setDialog(false)}>
				<Box sx={{ width: '20rem', padding: 3, height: '30rem', overflow: 'auto' }}>
					<Typography variant='subtitle1' textAlign='center'>Selecione os instrumentos</Typography>

					<Divider />
					{data.length > 0 &&
						<>
							<FormGroup>
								{data.map((index: any) => (
									<FormControlLabel key={index.uuid} control={<Checkbox checked={selected.includes(index.uuid)} onChange={() => handleToggle(index.uuid, index.nome)} />} label={index.nome} />
								))}
							</FormGroup>
							<Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
								<Button fullWidth onClick={csvDown} startIcon={<Download />} variant='contained' disabled={selected[0] === ''}>Baixar</Button>
							</Box>
						</>
					}
				</Box>
			</Dialog>
			{
				alertInfo.open && (
					<CustomAlert
						message={alertInfo.message}
						severity={alertInfo.severity}
						key={alertInfo.key}
					/>
				)
			}
		</LayoutBase>
	);
}